/** Only same-origin app paths are accepted as ?return= targets (no open redirect). */
export function safeReturn(v: string | null | undefined, fallback = '/'): string {
  if (!v) return fallback;
  if (!v.startsWith('/') || v.startsWith('//') || v.startsWith('/\\') || /[\r\n]/.test(v))
    return fallback;
  return v;
}
